<template>
  <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M6.411 1.167h13.637v8.658H6.41V1.167z"
        stroke="#ADADAD"
        fill="#FFF"
        stroke-dasharray="2.2,2"
      />
      <path fill="#FFF" d="M4 3h14v8H4z" />
      <path stroke="#ADADAD" fill="#FFF" d="M1 5.496h13.636v8.658H1z" />
      <path stroke="#ADADAD" d="M6.416 3.22V1.166h2.052" />
      <g stroke="#ADADAD">
        <path d="M17.996 1.166h2.054V3.22M20.05 7.78v2.053h-2.053" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSqFeet',
};
</script>

<style></style>
